import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import LegalContent from '../components/LegalContent';
import LoadingSpinner from '../components/LoadingSpinner';
import { publicAPI } from '../services/api';
import { canonicalUrlFor, metaDescription } from '../utils/seo';
import SEO from '../components/SEO';

const Terms: React.FC = () => {
  const [content, setContent] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    let mounted = true;
    publicAPI
      .getLegalContent('terms')
      .then((response) => {
        if (mounted) {
          setContent(response.data.content);
        }
      })
      .catch(() => {
        if (mounted) setError('Unable to load the Terms & Conditions right now.');
      });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Layout className="max-w-4xl space-y-6">
      <SEO
        title="Terms & Conditions – OppFoundry"
        description={metaDescription('OppFoundry terms of service and acceptable use.')}
        canonical={canonicalUrlFor()}
      />
      <h1 className="text-3xl font-semibold text-gray-900">Terms &amp; Conditions</h1>
      {error && <p className="text-sm text-rose-600">{error}</p>}
      {!content && !error ? (
        <LoadingSpinner message="Loading terms..." />
      ) : (
        content && <LegalContent html={content} />
      )}
    </Layout>
  );
};

export default Terms;
